<template>
    <div :class="containerClass" @click="onDocumentClick" class="bg-main ui-guard">
        <AppTopBar
            :title="title"
            :topbarMenuActive="topbarMenuActive"
            :activeTopbarItem="activeTopbarItem"
            :inlineUser="inlineUser"
            @right-menubutton-click="onRightMenuButtonClick"
            @menubutton-click="onMenuButtonClick"
            @topbar-menubutton-click="onTopbarMenuButtonClick"
            @topbar-item-click="onTopbarItemClick"
        >
        </AppTopBar>

        <transition name="layout-menu-container">
            <div class="layout-menu-container" @click="onMenuClick" v-show="isMenuVisible()">
                <div class="menu-scroll-content">
                    <div class="main-content">
                        <AppMenu :model="$store.state.appSupport.menu" :layoutMode="layoutMode" :active="menuActive" :mobileMenuActive="staticMenuMobileActive" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>
                    </div>
                </div>
            </div>
        </transition>

        <div class="layout-main">
            <div class="layout-content">
                <div class="main-content">
                    <router-view />
                </div>
            </div>
            <AppFooter />
        </div>

        <div class="layout-content-mask"></div>
        <Toast position="top-right"></Toast>
    </div>
</template>
<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppFooter from './AppFooter.vue';
import EventBus from './event-bus';
import { useToast } from 'primevue/usetoast';
import ProductService from './service/ProductService';
import SupplierService from './service/SupplierService';
import UtilService from './service/UtilService';
import MembershipService from './service/MembershipService';

export default {
    prodService: null,
    supplierService: null,
    membershipService: null,
    utilService: null,
    data() {
        return {
            title: '',
            supplierRefId: process.env.VUE_APP_SUPPLIER_REF_ID,
            memberPointConversionRate: null,
            supplier: {},
            layoutMode: 'horizontal',
            lightMenu: true,
            overlayMenuActive: false,
            staticMenuMobileActive: false,
            staticMenuDesktopInactive: false,
            isRTL: false,
            inlineUser: false,
            topbarMenuActive: false,
            activeTopbarItem: null,
            rightPanelMenuActive: null,
            inlineUserMenuActive: false,
            menuActive: false,
            //topbarColor: 'layout-topbar-light',
            topbarColor: 'layout-topbar-blue',

            //topbarColors: [
            //	{name: "Blue", topbarColor: "layout-topbar-blue", logo: "logo-store-white", color: "#0772B3"}
            //],
            theme: 'blue',
            //themeColors: [
            //	{name: "Green", file: "green", color: "#10B163"},
            //],
            menu: [],
            toast: null,
            toastMessage: { severity: 'info', summary: 'Store information is not avaliable!', detail: 'Please, select the store from marketplace.', life: 5000 },
        };
    },

    created() {
        this.title = process.env.VUE_APP_TITLE;

        this.utilService = new UtilService();
        this.prodService = new ProductService();
        this.supplierService = new SupplierService();
        this.membershipService = new MembershipService();

        /* I18N Message bundles added as of 2026 Sep */
        this.$retrieveMessageBundle(this);//load i18n message bundles
        
        this.$store.dispatch('createTitle', process.env.VUE_APP_QUOTE);

        this.$loadUserData(this);
        //console.log(this.prodService);
        //let path = this.$route.path;
        //console.log("Router Path:"+path);

        this.toast = useToast();

        let iconDataShow={
            isDisplable: true
        };

        let iconDataHide={
            isDisplable: false
        };

        let tempMenu = [
            {
                label: 'Main',
                id:'main',
                icon: 'pi pi-list',
                iconData: iconDataHide,
                items: [
                    {
                        id:'home',   
                        label: 'Home',
                        icon: 'pi pi-home',
                        iconData: iconDataShow,
                        command: () => {
                            this.$gotoMain(this);
                        },
                    },
                    {
                        id:'my_cart',
                        label: 'Cart',
                        icon: 'pi pi-shopping-cart',
                        iconData: iconDataShow,
                        command: () => {
                            this.$gotoCart(this);
                        },
                    },
                    {
                        id:'my_orders',
                        label: 'Orders',
                        icon: 'pi pi-objects-column',
                        iconData: iconDataShow,
                        command: () => {
                            this.$router.push({
                                path: '/my-orders',
                            });
                        },
                    },
                    {
                        id:'my_coupons',
                        label: 'Coupons',
                        icon: 'pi pi-money-bill',
                        iconData: iconDataShow,
                        command: () => {
                            this.$router.push({
                                path: '/my-coupons',
                            });
                        },
                    },
                ],
            },
            {
                id:'hot_deals',
                label: 'Hot Deals',
                icon: 'pi pi-shopping-bag',                
                iconData: iconDataHide,
                items: [
                    {
                        id:'promo_sales',
                        label: 'Promo Sales',
                        icon: 'pi pi-calculator',
                        iconData: iconDataShow,
                        command: () => {
                            this.$router.push({
                                path: '/promo-products',
                            });
                        },
                    },
                    {
                        id:'deal_of_the_month',
                        label: 'Deal of the Month',
                        icon: 'pi pi-briefcase',                        
                        iconData: iconDataShow,
                        command: () => {
                            this.$router.push({
                                path: '/deal-products',
                            });
                        },
                    },
                    {
                        id:'corporate_sales',
                        label: 'Corporate Sales',
                        icon: 'pi pi-building-columns',
                        iconData: iconDataShow,
                        command: () => {
                            this.$router.push({
                                path: '/corporate-sales',
                            });
                        },
                    },
                ],
            },
            {
                id:'shop',
                label: 'Product',
                icon: 'pi pi-shop',
                iconData: iconDataHide,
                items: [
                    {
                        id:'all',
                        label: 'All',
                        icon: 'pi pi-tags',
                        iconData: iconDataHide,
                        command: () => {
                            this.$router.push({
                                path: '/products',
                            });
                        },
                    },
                ],
            },            
            {
                id:'exploration',
                label: this.$store.state.i18n.messageBundle?.main_menu?.exploration,
                icon: 'pi pi-check-square',
                iconData: iconDataHide,
                items: [                    
                    {
                        id:'installations',
                        label: 'Installations',
                        icon: 'pi pi-wrench',
                        iconData: iconDataShow,
                        command: () => {
                            this.$router.push({
                                path: '/installation-services',
                            });
                        },
                    },
                    {
                        id:'digital_gift',
                        label: 'Digital Gift',
                        icon: 'pi pi-gift',
                        iconData: iconDataShow,
                        command: () => {
                            this.$router.push({
                                path: '/digital-gift',
                            });
                        },
                    },
                    {
                        id:'trendings',
                        label: 'Trendings',
                        icon: 'pi pi-star',
                        iconData: iconDataShow,
                        command: () => {
                            this.$router.push({
                                path: '/topics',
                            });
                        },
                    },
                    {
                        id:'check_coupon',
                        label: 'Coupon',
                        icon: 'pi pi-money-bill',
                        iconData: iconDataShow,
                        command: () => {
                            this.$router.push({
                                path: '/search-coupon',
                            });
                        },
                    },
                ],
            }
        ];

        
        this.$store.dispatch('createMenu', tempMenu);
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
    },
    mounted() {        
        this.loadData();
        this.$createLanguageSelectionFlag(this);
    },
    methods: {
        async loadData() {
            await this.loadSupplierData();
            await this.loadProductCategories();
            await this.loadMemberPointsConversion();
        },

        async loadSupplierData() {
            try {
                let data = await this.supplierService.fetchSupplier(this.supplierRefId);
                if (data) {
                    this.utilService.consoleLog('supplier:' + JSON.stringify(data));
                    this.supplier = data;
                    this.$addVisitedSupplier(this.supplier);
                    let currencyObj = { display: data['currency'], description: 'Store currency.' };
                    this.$store.dispatch('removeCurrency');
                    this.$store.dispatch('createCurrency', currencyObj);
                    this.$store.dispatch('createTitle', process.env.VUE_APP_QUOTE);
                    if (typeof Storage !== 'undefined') {
                        sessionStorage.setItem('currency', JSON.stringify(currencyObj));
                        sessionStorage.setItem('title', process.env.VUE_APP_SITE_DESC);
                    }
                }
            } catch (err) {
                let errObject = this.utilService.defineError(err);
                this.utilService.consoleLog('errObject:', errObject);
            }
        },
        async loadMemberPointsConversion(){
            try{
                
                let data = await this.membershipService.fetchMembershipRewardRate();
                if(data){
                    //
                    let rate=data.rate;
                    sessionStorage.setItem('pointRate', rate);
                }
            }catch (err) {
                let errObject = this.utilService.defineError(err);
                this.utilService.consoleLog('errObject:', errObject);
            }
        },
        async loadProductCategories() {
            try {
                let data = null;

                if (this.$store.state.prodSupport && this.$store.state.prodSupport.classifications) {
                    data = this.$store.state.prodSupport.classifications;
                } else {
                    //data = await this.prodService.fetchProductCategories(this.supplierRefId);
                    data = this.supplier.productClasses;
                    this.$store.dispatch('createProdClassifications', data);
                }

                this.utilService.consoleLog('cacheProdClassifications:', JSON.stringify(data));

                /*
                this.categories = this.supplier.productClasses.map((cat) => {
                    return { label: cat, value: cat };
                });
                */

                let refineData = data;
                if (data.length > 10) {
                    refineData = data.slice(0, 9);
                }

                let iconDataHide={
                    isDisplable: false
                };

                let classificationItems = refineData.map((cat) => {
                    return {
                        id: cat,
                        label: cat,
                        icon: 'pi pi-tags',
                        iconData: iconDataHide,
                        command: () => {
                            let queryData = {
                                selectedClassifications: [{ label: cat, value: cat }],
                                srt: 'asc',
                                idx: 1,
                                selectedPageSize: { label: '12 items per page', value: 12 },
                                supplierRefId: this.$retrieveSupplierRefId(),
                                layout: 'grid',
                                queryType: 'Filter',
                            };
                            this.$saveCacheData('prodQuery', queryData);

                            this.$router.push({
                                path: '/products',
                                query: { timestamp: Date.now() },
                            });
                        },
                    };
                });

                classificationItems.unshift({
                    id:'all',
                    label: 'All',
                    icon: 'pi pi-tags',
                    iconData: iconDataHide,
                    command: () => {
                        this.$saveCacheData('prodQuery', {});
                        this.$router.push({
                            path: '/products',
                            query: { timestamp: Date.now() },
                        });
                    },
                });

                let tempMenu = this.$store.state.appSupport.menu;

                let newMenu = tempMenu.map((m) => {
                    if (m.id === 'shop') {
                        m.items = classificationItems;
                    }
                    return m;
                });

                console.log("-------newMenu"+JSON.stringify(newMenu));

                this.$store.dispatch('createMenu', newMenu);
            } catch (err) {
                let errObject = this.utilService.defineError(err);
                this.utilService.consoleLog('errObject:', errObject);
            }
        },
        onDocumentClick() {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            if (!this.rightMenuClick) {
                this.rightPanelMenuActive = false;
            }

            if (!this.userMenuClick && this.isSlim() && !this.isMobile()) {
                this.inlineUserMenuActive = false;
            }

            if (!this.menuClick) {
                if (this.isHorizontal() || this.isSlim()) {
                    this.menuActive = false;
                }

                if (this.overlayMenuActive || this.staticMenuMobileActive) {
                    this.hideOverlayMenu();
                }

                EventBus.emit('reset-active-index');
                this.unblockBodyScroll();
            }

            if (this.userMenuClick) {
                this.menuActive = false;
                EventBus.emit('reset-active-index');
            }

            this.topbarItemClick = false;
            this.menuClick = false;
            this.rightMenuClick = false;
            this.userMenuClick = false;
        },
        onMenuButtonClick(event) {
            this.menuClick = true;
            this.topbarMenuActive = false;
            this.rightPanelMenuActive = false;

            if (this.layoutMode === 'overlay') {
                this.overlayMenuActive = !this.overlayMenuActive;
            }

            if (this.isDesktop()) this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
                if (this.staticMenuMobileActive) {
                    this.blockBodyScroll();
                } else {
                    this.unblockBodyScroll();
                }
            }

            event.preventDefault();
        },
        onTopbarMenuButtonClick(event) {
            this.topbarItemClick = true;
            this.topbarMenuActive = !this.topbarMenuActive;
            this.hideOverlayMenu();
            event.preventDefault();
        },
        onTopbarItemClick(event) {
            this.topbarItemClick = true;

            if (this.activeTopbarItem === event.item) this.activeTopbarItem = null;
            else this.activeTopbarItem = event.item;

            event.originalEvent.preventDefault();
        },
        onMenuClick() {
            this.menuClick = true;
        },
        onInlineUserClick() {
            this.userMenuClick = true;
            this.inlineUserMenuActive = !this.inlineUserMenuActive;
        },
        blockBodyScroll() {
            this.addClass(document.body, 'blocked-scroll');
        },
        unblockBodyScroll() {
            this.removeClass(document.body, 'blocked-scroll');
        },
        onRightMenuButtonClick(event) {
            this.rightMenuClick = true;
            this.rightPanelMenuActive = !this.rightPanelMenuActive;

            this.hideOverlayMenu();

            event.preventDefault();
        },
        onRightMenuClick() {
            this.rightMenuClick = true;
        },
        hideOverlayMenu() {
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
        },
        onMenuItemClick(event) {
            if (!event.item.items) {
                EventBus.emit('reset-active-index');
                this.hideOverlayMenu();
            }
            if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
                this.menuActive = false;
            }
        },
        onRootMenuItemClick() {
            this.menuActive = !this.menuActive;
        },
        isTablet() {
            let width = window.innerWidth;
            return width <= 1024 && width > 640;
        },
        isDesktop() {
            return window.innerWidth > 896;
        },
        isMobile() {
            return window.innerWidth <= 1025;
        },
        isHorizontal() {
            return this.layoutMode === 'horizontal';
        },
        isSlim() {
            return this.layoutMode === 'slim';
        },
        isMenuVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static') return !this.staticMenuDesktopInactive;
                else if (this.layoutMode === 'overlay') return this.overlayMenuActive;
                else return true;
            } else {
                return true;
            }
        },

        //change stylesheet
        changeStyleSheetUrl(id, value, prefix) {
            let element = document.getElementById(id);
            let urlTokens = element.getAttribute('href').split('/');
            urlTokens[urlTokens.length - 1] = prefix + '-' + value + '.css';
            let newURL = urlTokens.join('/');

            this.replaceLink(element, newURL);
        },
        //remove old link and add new one
        replaceLink(linkElement, href) {
            const id = linkElement.getAttribute('id');
            const cloneLinkElement = linkElement.cloneNode(true);

            cloneLinkElement.setAttribute('href', href);
            cloneLinkElement.setAttribute('id', id + '-clone');

            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove();
                cloneLinkElement.setAttribute('id', id);
            });
        },

        //add new css class
        addClass(element, className) {
            if (element.classList) element.classList.add(className);
            else element.className += ' ' + className;
        },
        //remove existing css class
        removeClass(element, className) {
            if (element.classList) element.classList.remove(className);
            else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
    },
    computed: {
        containerClass() {
            return [
                'layout-wrapper',
                {
                    'layout-horizontal': this.layoutMode === 'horizontal',
                    'layout-overlay': this.layoutMode === 'overlay',
                    'layout-static': this.layoutMode === 'static',
                    'layout-slim': this.layoutMode === 'slim',
                    'layout-menu-light': this.lightMenu === true,
                    'layout-menu-dark': this.lightMenu === false,
                    'layout-overlay-active': this.overlayMenuActive,
                    'layout-mobile-active': this.staticMenuMobileActive,
                    'layout-static-inactive': this.staticMenuDesktopInactive,
                    'layout-rtl': this.isRTL,
                    'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                    'p-ripple-disabled': this.$primevue.config.ripple === false,
                },
                this.topbarColor,
            ];
        },
    },
    components: {
        AppTopBar: AppTopBar,
        AppMenu: AppMenu,
        AppFooter: AppFooter,
    },
};
</script>
<style lang="scss">
.layout-wrapper {
    .layout-topbar {
        height: 72px !important;
        padding: 12px 20px !important;
    }

    .layout-menu-container {
        top: 72px !important;
    }
}

.layout-wrapper .layout-main {
    /*padding-top: 1px !important;*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
}

.bg-main {
    /*
    background: url("assets/images/bg/prof-bg.png");  
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;    
    */
    background-color: white;
}

.layout-wrapper .layout-main .layout-content {
    padding: 0px !important;
}

.main-content {
    width: 1400px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 15px;
    margin-bottom: 15px;
}

.ui-guard {
    opacity: 1;
}

@media screen and (max-width: 1456px) {
    .main-content {
        width: 100%;
        margin: auto;

        /*
        padding-top: 5px;    
        padding-bottom: 0px;*/
    }
}

@media screen and (min-width: 2500px) {
    .main-content {
        width: 90%;
        margin: auto;

        margin-left: auto;
        margin-right: auto;
        margin-top: 15px;
        margin-bottom: 15px;
    }
}

@media screen and (min-width: 4250px) {
    .main-content {
        width: 90%;
        margin: auto;
        margin-left: auto;
        margin-right: auto;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .ui-guard {
        opacity: 0;
    }
}

@media screen and (max-width: 896px) {
    .layout-wrapper {
        .layout-topbar {
            height: 72px !important;
            padding: 12px 20px !important;
        }
        /* If layout-topbar-search is included, layout-menu-container top margin must be 99px when in mobile view. */

        .layout-menu-container {
            top: 112px !important;
        }
    }

    .layout-wrapper .layout-main {
        /* If layout-topbar-search is included, padding-top must be 110px. */
        padding-top: 112px !important;
        //padding-top: 70px !important;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 100vh;
    }

    .layout-wrapper .layout-topbar .layout-topbar-search {
        top: 72px !important;
    }

    .layout-wrapper .layout-content-mask {
        top: 72px;
    }
}






</style>
